const pushFbPixelEvent = event => {
  if (typeof window !== "undefined") {
    if (window.fbq != null) window.fbq("track", event);
  }
};

export default pushFbPixelEvent;
